export default "__VITE_ASSET__C7f3GqS4__"